// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area .r-borderColor-g944k3{
  box-shadow: 0 0 0 1px rgb(220, 38, 38);
  border-color: rgb(220, 38, 38);
}
`, "",{"version":3,"sources":["webpack://./src/components/textArea/style.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,8BAA8B;AAChC","sourcesContent":[".text-area .r-borderColor-g944k3{\n  box-shadow: 0 0 0 1px rgb(220, 38, 38);\n  border-color: rgb(220, 38, 38);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
